<template>
    <div class="Introduct-container">
        <Header backgroundColor="#222733"></Header>
        <div class="Introduct-main">
            <div class="Introduct-main-left">
                <div class="yqb-top">
                    <img class="logo-yqb" src="../../public/imgs/logo1.png" alt="">
                    <span class="title-qyb">易启保</span>
                </div>
                <p class="qyb-introduction">本软件主要将市面上品质优良的保险产品汇聚起来放到一个平台中。原先客户如果想要找到一款适合自己的保险产品需要浪费许多的时间和精力，并且还不一定是适合自己的。而平台通过集合产品，使用大数据算法将产品进行标签分类，用户通过标签系统可以更快找到自己需要的产品，后期通过智能算法还可以获得产品的智能推荐，让每个用户根据自己的情况，获得平台为其量身定制的保险产品，从而获得性价比最高的保险服务。</p>
                <div class="labels">
                    <span class="label">精心筛选</span>
                    <span class="label">海量保险产品</span>
                    <span class="label">量身定制</span>
                    <span class="label">超高性价比</span>
                </div>
                <div class="download">
                    <div class="download-left">
                        <img src="../../public/imgs/download.png" alt="">
                        <img src="../../public/imgs/download1.png" alt="">
                    </div>
                    <div class="download-right">
                        <div class="download-img">
                            <img src="../../public/imgs/download-code.png" alt="">
                        </div>
                        <p>请用手机扫一扫下载APP</p>
                    </div>
                </div>
            </div>
            <div class="Introduct-main-right">
                <img class="phone"  src="../../public/imgs/phone.png" alt="">
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../components/Header'
    import Footer from '../components/Footer'

    export default {
        name: 'Introduct',
        data() {
            return {
            }
        },
        components: {
            Header,Footer
        },
        created() {
            this.$store.commit('changeNavs', 'Introduct')
        },
        methods: {

        },
        mounted() {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" type="text/less">
    .Introduct-container {
        position: relative;
        min-width: 1200px;
        /*background-color: #222733;*/
        .Introduct-main {
            display: flex;
            justify-content: center;
            padding-top: 110px;
            padding-bottom: 100px;
            background: url('../../public/imgs/Bg3.png') no-repeat center center;
            background-size: cover;
            box-sizing: border-box;
            .Introduct-main-left {
                width: 640px;
                margin-right: 50px;
                margin-top: 30px;
                .yqb-top {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-bottom: 30px;
                    .logo-yqb {
                        width: 60px;
                        height: 60px;
                        margin-right: 20px;
                    }
                    .title-qyb {
                        height: 64px;
                        line-height: 64px;
                        color: #fff;
                        font-size: 40px;
                    }
                }
                .qyb-introduction {
                    color: #fff;
                    font-size: 20px;
                    margin-bottom: 40px;
                    line-height: 30px;
                }
                .labels {
                    margin-bottom: 80px;
                    .label {
                        padding: 8px 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 3px;
                        margin-right: 10px;
                    }
                }
                .download {
                    display: flex;
                    justify-content: flex-start;
                    .download-left {
                        margin-right: 45px;
                        img {
                            width: 240px;
                            height: 60px;
                            display: block;
                            margin-top: 5px;
                            &:first-child {
                                margin-bottom: 35px;
                            }
                        }
                    }
                    .download-right {
                        display: flex;
                        align-items: center;
                        flex-flow: column;
                        .download-img {
                            width: 160px;
                            height: 160px;
                            border-radius: 8px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            background-color: #fff;
                            img {
                                width: 144px;
                                height: 144px;
                            }
                        }
                        p  {
                            color: #fff;
                            font-size: 16px;
                            line-height: 30px;
                            margin-top: 5px;
                        }
                    }
                }
            }
            .Introduct-main-right {
                .phone {
                    width: 534px;
                    height: 667px;
                }
            }
        }
    }
</style>
